import React from 'react';
import { Card, Button, Row, Col, Typography, Badge } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { getProductTitleById } from '../utils';

const AutoReloadCard = ({ autoChargeSettings, products, onOpenSettings, cardStyle }) => {
  const { t } = useTranslation();

  return (
    <Card
      style={{ ...cardStyle, height: '100%' }}
      title={t('auto_reload')}
      extra={
        <Button
          type="link"
          icon={<EditOutlined />}
          color="primary"
          onClick={onOpenSettings}
        >
          {t('edit')}
        </Button>
      }
    >
      <Row gutter={[24, 16]}>
        <Col span={8}>
          <div>
            <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
              {t('status')}
            </Typography.Text>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Badge status="success" />
              <Typography.Text strong style={{ fontSize: 14 }}>
                {t('active')}
              </Typography.Text>
            </div>
          </div>
        </Col>
        <Col span={8}>
          <div>
            <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
              {t('recharge_plan')}
            </Typography.Text>
            <Typography.Text strong style={{ fontSize: 14 }}>
              {t(getProductTitleById(products, autoChargeSettings?.auto_reload_product_id))}
            </Typography.Text>
          </div>
        </Col>
        <Col span={8}>
          <div>
            <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
              {t('trigger_at')}
            </Typography.Text>
            <Typography.Text strong style={{ fontSize: 14 }}>
              {autoChargeSettings?.auto_reload_threshold} {t('coins')}
            </Typography.Text>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default AutoReloadCard; 